import React, { FC, useEffect, useState } from "react";

import SectionHeader from "components/common/Ui/SectionHeader/SectionHeader";
import { ListTable } from "components/common/ListTable/ListTable";
import { TGetCurrentUserFinancialTransactionsParams } from "core/models/financial.model";
import { useGetCurrentUserFinancialTransactions } from "core/services/api/financial-transaction.api";
import { columns } from "./Columns";

const Transaction: FC = ({}) => {
  const [filterState, setFilterState] =
    useState<TGetCurrentUserFinancialTransactionsParams>({
      page: 1,
      pageSize: 10,
    });

  const [tableData, setTableData] = useState<any>([]);
  const [initialPage, setInitialPage] = useState<number>(0);
  const [pageCountList, setPageCount] = useState<number>(0);

  const { data, isSuccess, isFetching } =
    useGetCurrentUserFinancialTransactions(filterState);

  useEffect(() => {
    if (isSuccess && data?.data?.result) {
      const result = data?.data?.result;
      setTableData(result?.items);
      setPageCount(Math.ceil(result.totalCount / filterState.pageSize));
    }
  }, [data, isSuccess]);

  return (
    <>
      <SectionHeader title="لیست تراکنش های من" className="mb-5" />

      <ListTable
        columns={columns}
        isLoading={isFetching}
        onPageChange={({ page, pageSize }) => {
          setFilterState({
            page,
            pageSize,
          });
        }}
        tableData={tableData}
        pageCountList={pageCountList}
        customPageSize={filterState.pageSize}
        setPageSize={(val: any) => {
          setFilterState((prev: any) => ({ ...prev, pageSize: val }));
        }}
        initialPage={initialPage}
        setInitialPage={setInitialPage}
      />
    </>
  );
};

export { Transaction };
